import { useTranslation } from '../../i18n/LocaleContext';

export default function KycPromptModal({ open, onLater, onSetup }) {
  const { t } = useTranslation();

  if (!open) {
    return null;
  }

  return (
    <div className="trade-modal trade-modal--center">
      <button
        type="button"
        className="trade-modal__backdrop"
        aria-label={t('common.close')}
        onClick={onLater}
      />
      <div className="trade-modal__panel trade-modal__panel--compact kyc-prompt-modal">
        <header className="trade-modal__header">
          <h2>{t('common.hint')}</h2>
          <button
            type="button"
            className="trade-modal__close"
            aria-label={t('common.close')}
            onClick={onLater}
          >
            ×
          </button>
        </header>
        <div className="kyc-prompt-modal__body">
          <div className="kyc-prompt-modal__icon" aria-hidden>
            ×
          </div>
          <p>{t('kyc.promptMessage')}</p>
          <div className="kyc-prompt-modal__actions">
            <button type="button" className="kyc-prompt-modal__later" onClick={onLater}>
              {t('kyc.verifyLater')}
            </button>
            <button type="button" className="kyc-prompt-modal__setup" onClick={onSetup}>
              {t('kyc.setupNow')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
